import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import React from 'react';
import SkillzSVG from 'SkillzSVG';
import {_m} from 'INTL';
import {LINK_BANK_BUTTON_TEXT} from './BankWithdrawalConstants';
import {default as SkillzStyle} from 'SkillzStyle';

const {fontExtraBold} = SkillzStyle.fullStyles;

type LinkBankButtonProps = {
  onPress?: () => void;
};

const LinkBankButton = ({onPress}: LinkBankButtonProps) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={onPress} style={styles.linkBankAccountButton}>
        <SkillzSVG style={styles.buttonIcon} source={'bank_icon_blue.svg'} />
        <Text style={styles.linkBankAccountButtonText} allowFontScaling={false}>
          {LINK_BANK_BUTTON_TEXT}
        </Text>
        <SkillzSVG style={styles.rightArrowIcon} source={'right_arrow_blue.svg'} />
      </TouchableOpacity>
    </View>
  );
};

export default LinkBankButton;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  linkBankAccountButton: {
    backgroundColor: '#E9F4FE',
    borderColor: '#5796CB',
    borderWidth: 1,
    padding: 10,
    borderRadius: 4,
    height: 40,
    width: 220,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  linkBankAccountButtonText: {
    fontSize: 14,
    color: '#367BCE',
    textAlign: 'center',
    ...fontExtraBold,
  },
  buttonIcon: {
    width: 20,
    height: 20,
  },
  rightArrowIcon: {
    width: 10,
    height: 13,
  },
});
